var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.424028,
    y: 1.22261,
    width: 41.5548,
    height: 41.5548,
    rx: 20.7774,
    fill: "#2AA663"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.424028,
    y: 1.22261,
    width: 41.5548,
    height: 41.5548,
    rx: 20.7774,
    stroke: "#2AA663",
    strokeWidth: 0.848056
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4601 16.7215V27.8234H21.449V18.6784H21.3839L18.7874 20.3372V18.4941L21.5466 16.7215H23.4601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle1);
export default __webpack_public_path__ + "static/media/Circle1.096b879359adddf936ed61e3821380b3.svg";
export { ForwardRef as ReactComponent };